import axios, { AxiosResponse } from 'axios'
const api = '/api/'

const termList = async ({ params }) => {
  const response = await axios.get(`${api}term/list`, params)
  return response.data
}

const termCreate = async ({ data }) => {
  await axios.post(`${api}term/store`, data)
}

const termEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}term/edit/${id}`)
  return response.data
}

const termDelete = async (id: string) => {
  await axios.get(`${api}term/destroy/${id}`)
}

const termView = async (id: string) => {
  const response = await axios.get(`${api}term/view/${id}`)
  return response.data
}

const getFaculties = async (id: string) => {
  const response = await axios.get(`${api}term/get-faculties/${id}`)
  return response.data
}

const getDeps = async (id: string) => {
  const response = await axios.get(`${api}term/get-deps/${id}`)
  return response.data
}

const termClassList = async (term_id: string) => {
  const response = await axios.get(`${api}term/classes/${term_id}`)
  return response.data
}

const termClassCreate = async ({ data }) => {
  await axios.post(`${api}term/class-store`, data)
}

const termClassEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}term/class-edit/${id}`)
  return response.data
}

const termClassDelete = async (id: string) => {
  await axios.get(`${api}term/class-destroy/${id}`)
}

const termClassSubjectCreate = async ({ data }) => {
  await axios.post(`${api}term/class-semester-store`, data)
}

const termClassSemesterCreate = async ({ data }) => {
  await axios.post(`${api}term/class-semester-store`, data)
}

const termClassSemesterList = async (term_id: string) => {
  const response = await axios.get(`${api}term/class-semester-list/${term_id}`)
  return response.data
}

const termClassSemesterEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}term/class-semester-edit/${id}`)
  return response.data
}

const termClassScheduleList = async ({ params }) => {
  const response = await axios.get(`${api}term/class-schedule-list`, params)
  return response.data
}

const termSemesterScheduleDropDownData = async ({ params }) => {
  const response = await axios.get(`${api}term/semester-schedule-data`, params)
  return response.data
}

const termSemesterScheduleCreate = async ({ data }) => {
  await axios.post(`${api}term/semester-schedule-store`, data)
}

const termSemesterScheduleEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}term/semester-schedule-edit/${id}`)
  return response.data
}

const termSemesterScheduleUpdate = async ({ data }) => {
  await axios.post(`${api}term/semester-schedule-update`, data)
}

const termSemesterScheduleDelete = async (id: string) => {
  await axios.get(`${api}term/semester-schedule-delete/${id}`)
}

const academicService = {
  termClassSubjectCreate,
  termClassList,
  termClassCreate,
  termClassEdit,
  termClassDelete,
  getDeps,
  getFaculties,
  termList,
  termCreate,
  termEdit,
  termDelete,
  termView,
  termClassSemesterCreate,
  termClassSemesterList,
  termClassSemesterEdit,
  termClassScheduleList,
  termSemesterScheduleDropDownData,
  termSemesterScheduleCreate,
  termSemesterScheduleEdit,
  termSemesterScheduleUpdate,
  termSemesterScheduleDelete
}

export default academicService
